var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tooltip",
    class: [_vm.direction]
  }, [_vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.content))];
  }), _vm._v(" "), _c('div', {
    staticClass: "tooltip-pointer"
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };